import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "pan",
  "use": "pan-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"pan\"><path d=\"M9 8a1 1 0 1 0 0 2 1 1 0 0 0 0-2m6.624-2.416a.75.75 0 1 0-1.248.832l1.223 1.834h-1.674C13.56 5.847 11.504 4 9 4S4.44 5.847 4.076 8.25H2.401l1.223-1.834a.75.75 0 0 0-1.248-.832L.099 9l2.277 3.416a.75.75 0 0 0 1.248-.832L2.401 9.75h1.674C4.44 12.153 6.496 14 9 14s4.56-1.847 4.924-4.25h1.674l-1.223 1.834a.75.75 0 0 0 1.248.832L17.901 9zM9 12.5c-1.93 0-3.5-1.57-3.5-3.5S7.07 5.5 9 5.5s3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol